import { LocalDate, LocalDateTime, LocalTime, ZoneId, ZonedDateTime } from 'js-joda';
import { getLocalDateTimesAfterNow } from 'utils/timeUtils';

/**
 * Accepts a date and a time, and an optional dateEnd.
 * Returns a new date if it is in the past set to the date it was called
 * @param date
 * @param time
 * @param dateEnd
 */
export const getRealDateTimes = (
  date: LocalDate,
  time: LocalTime,
  timeZone: string,
  dateEnd?: LocalDate
): {
  realDateDateTime: LocalDateTime;
  realDateEndDateTime: LocalDateTime | undefined;
} => {
  const dateLocalDateTime = LocalDateTime.of(date, time);
  const dateEndLocalDateTime = dateEnd ? LocalDateTime.of(dateEnd, LocalTime.MAX) : undefined;
  const zonedNow = ZonedDateTime.now(ZoneId.of(timeZone));
  const now = zonedNow.toLocalDateTime();

  const isPastDateLocalDateTime = dateLocalDateTime.isBefore(now);
  const isPastDateEndLocalDateTime = dateEndLocalDateTime
    ? dateEndLocalDateTime.isBefore(now)
    : false;

  const localDateTimesAfterNow = getLocalDateTimesAfterNow(
    isPastDateLocalDateTime ? now.toLocalDate() : date,
    isPastDateLocalDateTime ? now.toLocalTime() : time,
    30
  );

  const realDateDateTime = isPastDateLocalDateTime
    ? localDateTimesAfterNow?.[0] ?? now
    : dateLocalDateTime;
  const realDateEndDateTime = isPastDateEndLocalDateTime
    ? localDateTimesAfterNow?.[0] ?? now
    : dateEndLocalDateTime;

  return {
    realDateDateTime,
    realDateEndDateTime,
  };
};
